export function appendFormValue(formData, key, value) {
  if (value === undefined || value === null || value === '') return;

  if (typeof value === 'boolean') {
    formData.append(key, String(value));
    return;
  }

  if (Array.isArray(value) || (typeof value === 'object' && value !== null)) {
    formData.append(key, JSON.stringify(value));
    return;
  }

  formData.append(key, String(value));
}

export function appendFiles(formData, fieldName, files = []) {
  files.forEach((file) => {
    if (file instanceof File) {
      formData.append(fieldName, file);
    }
  });
}
